<!-- NOT FORMAT FOR DATETIME YET -->
<template>
  <v-date-picker
    ref="datePicker"
    :key="key"
    v-model="datetimeRangeData"
    locale="vi-VN"
    color="green"
    :first-day-of-week="2"
    :max-date="minMax.max"
    :min-date="minMax.min"
    :masks="masks"
    :attributes="attrs"
    :is-required="true"
    is-range
    :mode="'date'"
    :popover="popover"
    is24hr
    @popoverWillShow="onOpen"
    @popoverWillHide="onClose"
    @input="
      $emit('input', {
        start: dayjs($event.start).format('YYYY-MM-DD'),
        end: dayjs($event.end).format('YYYY-MM-DD')
      })
    "
  >
    <template v-slot="{ inputValue, isDragging, togglePopover }">
      <div
        v-if="disabled"
        class="date-picker"
        style="opacity: 0; position: absolute; width: 500px; z-index: 10"
      />
      <div style="display: flex; align-items: center">
        <div
          class="flex items-center date-picker"
          :class="{ isError: isError, isDisabled: disabled }"
          @click="
            togglePopover({
              placement: popOverDirection,
              visibility: 'hidden'
            })
          "
        >
          <input
            class="vc-input"
            :class="isDragging ? 'text-gray-600' : 'text-gray-900'"
            :value="inputValue.start"
            style="display: none"
            @click="
              togglePopover({
                placement: popOverDirection,
                visibility: 'hidden'
              })
            "
          />
          <calendar-input
            :value="
              !!datetimeRangeData.start
                ? dayjs(datetimeRangeData.start).format('YYYY-MM-DD HH:mm:ss')
                : null
            "
            :disabled="disabled"
            input-classes="otp-input"
            :should-auto-focus="false"
            :num-inputs="mode === 'date' ? 3 : 5"
            @on-change="handleOnChangeStart"
            @on-complete="handleOnCompleteStart"
          />
        </div>
        <span class="date-divide" />
        <div
          class="flex items-center date-picker"
          :class="{ isError: isError, isDisabled: disabled }"
          @click="
            togglePopover({
              placement: popOverDirection,
              visibility: 'hidden'
            })
          "
        >
          <input
            class="vc-input"
            :class="isDragging ? 'text-gray-600' : 'text-gray-900'"
            :value="inputValue.end"
            style="display: none"
            @click="
              togglePopover({
                placement: popOverDirection,
                visibility: 'hidden'
              })
            "
          />
          <calendar-input
            :value="
              !!datetimeRangeData.end
                ? dayjs(datetimeRangeData.end).format('YYYY-MM-DD HH:mm:ss')
                : null
            "
            :disabled="disabled"
            input-classes="otp-input"
            :should-auto-focus="false"
            :num-inputs="mode === 'date' ? 3 : 5"
            @on-change="handleOnChangeEnd"
            @on-complete="handleOnCompleteEnd"
          />
        </div>
      </div>

      <!-- <button
        @click="
          datetimeRangeData = { start: null, end: null }
          $emit('input', datetimeRangeData)
        "
      >
        test
      </button> -->
    </template>
    <!-- <template v-slot:footer>
        <div class="vc-footer">
          <button class="btn second" @click="$emit('resetCalendar')">
            초기화
          </button>
          <button class="btn tert" @click="$emit('setCalendar')">확인</button>
        </div>
      </template> -->
  </v-date-picker>
</template>

<script>
import * as dayjs from 'dayjs'
import CalendarInput from './CalendarInput.vue'

export default {
  components: {
    'calendar-input': CalendarInput
  },
  props: {
    value: null,
    mode: {
      type: String,
      default: 'date' // dateTime
    },
    disabled: {
      type: Boolean
    },
    minMax: {
      type: Object,
      default: () => ({ min: null, max: null }) // YYYY-MM-DD HH:mm
    },
    isError: {
      type: Boolean,
      default: false
    },
    popOverDirection: {
      type: String,
      default: 'bottom-start'
    }
  },
  data() {
    return {
      key: 1000,
      datetimeRangeData: {
        start: this.value.start,
        end: this.value.end
      },

      bgActive: false,
      masks: {
        inputDateTime24hr: [
          'DD-MM-YYYY HH:mm:ss',
          'DD/MM/YYYY HH:mm',
          'YYYY-MM-DD HH:mm:ss',
          'YYYY/MM/DD HH:mm'
        ],
        input: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD', 'DD-MM-YYYY', 'DD/MM/YYYY']
      },
      attrs: [
        {
          key: 'today',
          highlight: {
            color: '#346cec',
            fillMode: 'outline'
          },
          dates: new Date()
        }
      ]
    }
  },
  computed: {
    dayjs() {
      return dayjs
    },
    popover() {
      return {
        visibility: this.disabled ? 'hidden' : 'hover-focus'
      }
    }
  },
  watch: {
    value(nv, ov) {
      // now it only works for date mode
      if (this.value) {
        if (!nv?.start && !nv?.end) {
          this.datetimeRangeData = {
            start: null,
            end: null
          }
          this.key++
        }
        if (this.mode === 'datetime') {
          this.datetimeData = dayjs(this.value, 'YYYY-MM-DD HH:mm:ss').format(
            'YYYY-MM-DD HH:mm:ss'
          )
        } else {
          this.datetimeRangeData = {
            // start: dayjs(this.value.start, 'YYYY-MM-DD').format(
            //   'YYYY-MM-DD HH:mm:ss'
            // ),
            // end: dayjs(this.value.end, 'YYYY-MM-DD').format(
            //   'YYYY-MM-DD HH:mm:ss'
            // )
            start: this.value.start,
            end: this.value.end
          }
        }
      } else {
        this.datetimeRangeData = {
          start: null,
          end: null
        }
      }
    }
  },

  mounted() {
    document.addEventListener('keyup', event => {
      if ((event.keyCode === 8 || event.keyCode === 46) && this.bgActive) {
        this.range = {
          start: null,
          end: null
        }
      }
    })
  },

  methods: {
    handleOnCompleteStart(value) {
      // convert back to 'backend' format
      if (this.mode === 'datetime') {
        this.datetimeData = dayjs(value, 'DD-MM-YYYY HH:mm:ss').format(
          'YYYY-MM-DD HH:mm:ss'
        )
      } else {
        this.datetimeRangeData.start = dayjs(value, 'DD-MM-YYYY').format(
          'YYYY-MM-DD'
        )
      }
      this.$emit('input', this.datetimeRangeData) // only emit out to parent when the input is complete
    },
    handleOnChangeStart(value) {
      // on delete all input
      if (!value) {
        this.$emit('input', { ...this.datetimeRangeData, start: null })
      }
    },
    handleOnCompleteEnd(value) {
      // convert back to 'backend' format
      if (this.mode === 'datetime') {
        this.datetimeData = dayjs(value, 'DD-MM-YYYY HH:mm:ss').format(
          'YYYY-MM-DD HH:mm:ss'
        )
      } else {
        this.datetimeRangeData.end = dayjs(value, 'DD-MM-YYYY').format(
          'YYYY-MM-DD'
        )
      }
      this.$emit('input', this.datetimeRangeData) // only emit out to parent when the input is complete
    },
    handleOnChangeEnd(value) {
      // on delete all input
      if (!value) {
        this.$emit('input', { ...this.datetimeRangeData, end: null })
      }
    },
    onOpen() {
      this.bgActive = true
    },
    onClose() {
      this.bgActive = false
    }
  }
}
</script>

<style lang="scss" scoped>
// ============================== V Calendar ========================================== //
.date-picker,
.date-picker-range {
  display: flex;
  align-items: center;
  position: relative;

  &:not(.date-picker-range) {
    flex: auto;
    height: 32px;
    padding: 0 10px;
    // border: solid 1px #d8dee5;
    border-radius: 5px;
    background: #f0f0f5 url('../../styles/images/svg/mci_calendar_icon.svg')
      no-repeat calc(100% - 10px) 50%;

    &.isError {
      border-color: red;
    }
    &.isDisabled {
      background: #f5f7fa;
    }
  }

  .vc-input {
    background: url('../../styles/images/svg/mci_calendar_icon.svg') no-repeat
      calc(100% - 10px) 50%;
    padding-left: 10px;
    // width: 160px;
    min-width: 160px;
    width: 100%;
    height: 32px;
    box-sizing: border-box;
    font-size: 1rem;
    background-color: #f0f0f5;
    border: 1px solid red !important;
    border-radius: 5px;

    &:focus {
      border: 1px solid red !important;
    }

    &.isError {
      border: 1px solid red !important;
    }

    &:disabled {
      background: #eceef0;
    }
  }
}

.overrideWidth {
  width: 150px !important;
}

.dateTimeMode {
  width: 180px !important;
}
</style>
